import { render, staticRenderFns } from "./FieldComparisonDiff.vue?vue&type=template&id=c51f6734&scoped=true&"
import script from "./FieldComparisonDiff.vue?vue&type=script&lang=js&"
export * from "./FieldComparisonDiff.vue?vue&type=script&lang=js&"
import style0 from "./FieldComparisonDiff.vue?vue&type=style&index=0&id=c51f6734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51f6734",
  null
  
)

export default component.exports